import { http } from "../Common/http";
import React from "react";
import { useAuth } from "../Auth/Auth";
import { Checkbox } from "antd";

interface Props {
  fid?: string;
  width?: number;
  value?: string[];
  onChange?: (value: string | undefined) => void;
}
export interface CommonMasterData {
  id: string;
  name: string;
}
interface CheckboxOptionData {
  label: string;
  value: string;
}

export const getCommonMasterDocuments = async (
  accessToken: string,
  fid?: string
): Promise<CommonMasterData[]> => {
  const result = await http<CommonMasterData[]>({
    path: "/Master/50?fid=" + fid,
    accessToken,
  });
  if (result.ok && result.body) {
    return result.body;
  } else {
    return [];
  }
};

export const DocumentCheckbox = ({
  fid,
  width = 560,
  value,
  onChange,
}: Props) => {
  const { accessToken } = useAuth();
  const [options, setOptions] = React.useState<CheckboxOptionData[]>([]);
  //const [selValue, setSelValue] = React.useState(value);
  React.useEffect(() => {
    const doGetMasterDatas = async () => {
      const gotDatas = await getCommonMasterDocuments(accessToken, fid);
      const options: CheckboxOptionData[] = gotDatas.map(
        (value: CommonMasterData, _index) => {
          const option: CheckboxOptionData = {
            label: value.name,
            value: value.id,
          };
          return option;
        }
      );
      setOptions(options);
    };
    doGetMasterDatas();
  }, [fid, accessToken]);

  const onSelectChange = (newValue: any) => {
    onChange?.(newValue);
  };

  /*
  const onSelectClear = () => {
    onChange?.(undefined);
  };
  */

  return (
    <Checkbox.Group
      style={{ width: width }}
      options={options}
      value={value}
      onChange={onSelectChange}
    />
  );
};
